var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.allCivilCases)?_c('ListPage',{attrs:{"gridData":_vm.filteredData,"gridConfig":_vm.gridConfig,"filters":_vm.filters}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }